import script from "./shrink.vue?vue&type=script&setup=true&lang=ts"
export * from "./shrink.vue?vue&type=script&setup=true&lang=ts"

import "./shrink.vue?vue&type=style&index=0&id=1fbfdb3c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbfdb3c"]])

export default __exports__